export default __webpack_public_path__ + "static/media/ic_reproved-kyb.540f6ec0.svg";